import React from 'react';
import Grid from "@material-ui/core/Grid";
import image from "../assets/img/faces/avatar.jpg";
import Typical from "react-typical";
import Footer from '../Components/Footer/Footer';
import './Home.css';

const Home = (props) =>{
    return(
        <div style={{  color: "white",height:'100%' }}>
            <div className="container">
                <div className="row">
                <div className="home-photo" >
                    <div
                      className="hp-inner"
                      style={{ backgroundImage: `url(${image})` }}
                     ></div>
                </div>
                    <Grid item xs={12} md={12} lg={12}>
                        <h3 className="typical">
                    I Am{" "}
                    <Typical
                      steps={["Ankur Barve.",
                        3000,
                        "Web Developer.",
                        3000,
                        "React-Native Developer.",
                        3000,
                        "Freelancer.",3000
                      ]}
                      loop={Infinity}
                      wrapper="b" />
                  </h3>
                  <p style={{textAlign:'center',fontSize:20}}>Hi there, I'm self-motivated react developer looking
                    ahead to help you out with your application.I have hands-on
                    experience in React Native, React , Redux, Firebase, MongoDB, Node, Express, PostgreSQL, JSON, HTML/CSS.</p>
                    </Grid>
                </div>
            </div>
           <div >
           <Footer/>
           </div>
        </div>
    );
};
export default Home;